export default {
  loading: false,
  error: null,
  typesOfClaim: null
}
